$(document).ready(function () {
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
        },
      },
    ],
  });

  $("#client-review-slide .review-text-wrapper").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 1000,
    fade: true,
    draggable: true,
    asNavFor: "#client-review-slide .review-slider-logo",
  });

  $("#client-review-slide .review-slider-logo").slick({
    slidesToShow: 3,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    centerMode: true,
    draggable: false,
    asNavFor: "#client-review-slide .review-text-wrapper",
  });

  $(".size-chart-btn").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-fade",
  });

  // PRODUCT Tabs JS start
  // Show the first tab and hide the rest
  $(".tabs-nav li:first-child").addClass("active-tab");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  $(".tabs-nav li").click(function () {
    $(".tabs-nav li").removeClass("active-tab");
    $(this).addClass("active-tab");
    $(".tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  jQuery(document).on("click", ".deliver_button", function () {
    var zipcode = jQuery("#deliver_zipcode").val();
    var pincodeGroup1Arr = pincodegroup1.split(",");
    var pincodeGroup2Arr = pincodegroup2.split(",");
    if (zipcode != "" && zipcode != undefined) {
      jQuery(".message-text").hide();
      console.log(pincodeGroup1Arr);
      //jQuery(".check_delivery_date-popup").hide();
      //jQuery('body').removeClass('popup-open-new');
      jQuery("#deliver_zipcode").val("");
      if ($.inArray(zipcode, pincodeGroup1Arr) !== -1) {
        jQuery(".message-group1").show();
      } else if ($.inArray(zipcode, pincodeGroup2Arr) !== -1) {
        jQuery(".message-group2").show();
      } else {
        jQuery(".message-other").show();
      }
    }
  });

  // Read More Raead Less js start
  // $('.products-tabs .show-hide-btn').click(function() {
  //   $('.products-tabs .show-hide-content').toggleClass('content-vissible');
  //   console.log($('.products-tabs .show-hide-btn').text());
  //     if ($('.products-tabs .show-hide-btn').text() == "Read More") {
  //       $(this).text("Read Less")
  //     } else {
  //       $(this).text("Read More")
  //     }
  // });

  // Quality Tab js start
  $(".quality-tab-btn").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-fade",
  });
});

$(document).on("click", ".slick--slide__zoom img", function () {
  console.log($(this).find(".zooom").html());
  $(this).parent().find(".zooom").trigger("click");
});

$(document).on("click", ".header.dismiss ", function () {
  $("#globo-formbuilder-59134").hide();
  jQuery("body").removeClass("notify-popup");
});

//SALES PAGE PRODUCT ATC JS START
$(document).ready(function () {
  $(document).on("click", ".home-product-atc", function (e) {
    e.preventDefault();
    var currentElement = $(this);
    if (currentElement.attr("data-id")) {
      var variant_id = currentElement.attr("data-id");
    } else {
      var variant_id = currentElement
        .parents(".select_bundal_wrapper")
        .find(".bundal_select_wrapper option:selected")
        .val();
      if (typeof variant_id === "undefined") {
        var variant_id = currentElement
          .parents(".bottom_footer")
          .find(".bundal_select_wrapper option:selected")
          .val();
      }
    }

    var quantity = 1;

    var itemsArray = [];
    var customItem = { id: variant_id, quantity: quantity };
    itemsArray.push(customItem);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: { items: itemsArray },
      success: function (success_data) {
        window.location.href = "/cart";
        SLIDECART_UPDATE();
        SLIDECART_OPEN();
      },
      error: function (data) {
        alert(data.responseJSON.description);
      },
    });
  });
});

//SALES PAGE PRODUCT ATC JS END

/*
$(document).ready(function () {
  // Add click event to all elements with the class 'plus_btn'
  $('.plus_btn').on('click', function () {
    // Get the ID of the clicked button
    const buttonId = $(this).attr('id');

    // Find the corresponding product form by the same ID
    const $productForm = $(`product-form#${buttonId}`);

    if ($productForm.length) {
      // Find the submit button inside the form and trigger a click
      const $submitButton = $productForm.find('button[type="submit"]');
      if ($submitButton.length) {
        $submitButton.trigger('click');
      } else {
        console.error('Submit button not found inside form:', buttonId);
      }
    } else {
      console.error('Form not found for ID:', buttonId);
    }
  });
});
*/

$(document).on("change", '[name="Length"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Material"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = lendthVal + "_" + mateialVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Material"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Material"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Length"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = lengthVal + "_" + mateialVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Length"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Gender"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Size"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = lendthVal + "_" + mateialVal;
      console.log("----<", finalVal);
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Size"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Size"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Gender"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = lengthVal + "_" + mateialVal;
      console.log("----<", finalVal);
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      console.log("----<", finalVid);
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Gender"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Color"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var lendthVal = $(this).val();
    var finalVid = "";
    var mateialVal = $("#variant_box_" + pid)
      .find('[name="Ring size"]:checked')
      .val();
    if (mateialVal != undefined) {
      var finalVal = mateialVal + "_" + lendthVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if (
      $("#variant_box_" + pid).find('[name="Ring size"]').length == 0
    ) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + lendthVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("change", '[name="Ring size"]', function (e) {
  if ($(this).is(":checked")) {
    var pid = $(this).attr("data-pid");
    var mateialVal = $(this).val();
    var finalVid = "";
    var lengthVal = $("#variant_box_" + pid)
      .find('[name="Color"]:checked')
      .val();
    if (lengthVal != undefined) {
      var finalVal = mateialVal + "_" + lengthVal;
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + finalVal)
        .attr("data-pre");
    } else if ($("#variant_box_" + pid).find('[name="Color"]').length == 0) {
      var finalVid = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .val();
      var finalVidAva = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-ava");
      var finalVidPre = $("#home-product-pop--" + pid)
        .find("#" + mateialVal)
        .attr("data-pre");
    }
    if (finalVid != "") {
      if (finalVidAva == "true") {
        var addText = "Add To Cart";
        if (finalVidPre != "") {
          addText = finalVidPre;
        }
        $("#popup_btn_" + pid).removeAttr("disabled");
        $("#popup_btn_" + pid).text(addText);
        $("#home_p_hiden_id_" + pid).val(finalVid);
      } else {
        $("#popup_btn_" + pid).attr("disabled", true);
        $("#popup_btn_" + pid).text("Sold out");
      }
    }
  }
});

$(document).on("click", ".popup_btn_atc", function (e) {
  var pid = $(this).attr("data-pid");
  console.log("--->", "#" + pid + "-submit_pop_home");
  $("#" + pid + "-submit_pop_home").trigger("click");
  setTimeout(function () {
    $("#home-product-pop--" + pid).hide();
    $("#home-product-pop--" + pid).removeClass("pd_popup__open");
    $("body").removeClass("product_details_popup--active");
  }, 1000);
});

$(document).on("click", ".home-product-atc-45", function (e) {
  var pid = $(this).attr("data-id");
  $("#" + pid + "-submit-cartadd").trigger("click");
});

// PRODUCT DETAILS POPUP -- START

jQuery(document).ready(function () {
  //jQuery(".plus_btn").on("click", function () {
  jQuery(document).on("click", ".plus_btn", function () {
    const buttonId = $(this).attr("data-pid");
    $("#home-product-pop--" + buttonId).show();
    $("#home-product-pop--" + buttonId).addClass("pd_popup__open");
    $("body").addClass("product_details_popup--active");
  });
  jQuery(document).on("click", ".pd_popup_close", function () {
    const buttonId = $(this).attr("data-pid");
    $("#home-product-pop--" + buttonId).hide();
    $("#home-product-pop--" + buttonId).removeClass("pd_popup__open");
    $("body").removeClass("product_details_popup--active");
  });
});

// PRODUCT DETAILS POPUP -- END

$(".filter-tab-wrapper")
  .find(".tab-wrapper")
  .find("li")
  .on("click", function () {
    $(".filter-tab-wrapper")
      .find(".tab-wrapper")
      .find("li")
      .removeClass("active");
    $(this).addClass("active");
    $("#product-grid").find(".grid__item").hide();
    var selVal = $(this).attr("data-value");
    $("#product-grid")
      .find("." + selVal)
      .show();
  });

// COLLECTION PAGE LOAD MORE BUTTON CLICK DATA PAGINATION START JS
let $button;
let $productCountText;
let $productGrid;
let totalProducts;
let loadedProducts;
let perPage;
$(document).ready(function () {
  $button = $("#load-more");
  $productCountText = $(".product-counter-wrapper");
  $productGrid = $("#product-grid");

  if (!$button.length) return;

  totalProducts = parseInt($button.attr("data-total-products"));
  perPage = parseInt($button.attr("data-per-page"));
  loadedProducts = $productGrid.find(".grid__item").length;

  // Initialize
  toggleButtonVisibility();
  updateProductCounter();
});
//Sort change event
$(document).on("change",'[name="sort_by"]',function(){
  resetAllData();
});

//Filter All Remove Event
$(document).on("click",'.new-filter-wrapper .active-facets__button-remove,.active-facets .active-facets__button-inner',function(){
  resetAllData();
});

//Filter Price Change Event
$(document).on("keyup",'.new-filter-wrapper [name="filter.v.price.lte"]',function(){
  resetAllData();
});

function resetAllData(){
  setTimeout(function(){
    $("#load-more").attr("data-page", 2).show();
    $("#product-grid").removeClass("loading");
    $button = $("#load-more");
    $productCountText = $(".product-counter-wrapper");
    $productGrid = $("#product-grid");

    if (!$button.length) return;

    totalProducts = parseInt($button.attr("data-total-products"));
    perPage = parseInt($button.attr("data-per-page"));
    loadedProducts = $productGrid.find(".grid__item").length;

    updateProductCounter();
  },3000);
}

// Attach click event
$(document).on("click", "#load-more", function () {
  loadMoreProducts();
});

// Load More Function
function loadMoreProducts() {
  let page = parseInt($button.attr("data-page"));
  loadedProducts = $productGrid.find(".grid__item").length;
  let collectionUrl = $button.attr('data-collection-url');
  //console.log("function load page",page,loadedProducts);
  console.log("collectionUrl",collectionUrl);
  let url = window.location.origin + "/" + collectionUrl + "?page=" + page,
      queryString = window.location.search;
  //url = `${window.location.pathname}?page=${page}`;

  if (queryString) {
    let rawQueryString = queryString.substring(1);
    var mainurl = window.location.href;
    console.log("mainurl",mainurl);
    url = mainurl + "&page=" + page;
  }
  $.ajax({
    url: url,
    type: "GET",
    beforeSend: function () {
      $button.text("Loading...");
    },
    success: function (data) {
      const $newProducts = $(data).find("#product-grid .grid__item");
      // console.log("function load newProducts",$productGrid,loadedProducts);
      if ($newProducts.length) {
        $productGrid.append($newProducts);
        loadedProducts += parseInt($newProducts.length);
        page++;

        $button.attr("data-page", page);
        updateProductCounter();
        //console.log("totalProducts",totalProducts,loadedProducts);
        if (loadedProducts >= totalProducts) {
          loadedProducts = totalProducts;
          $button.hide();
          $productCountText.hide();
          $productGrid.addClass("all-products-loaded");
        } else {
          $button.text("Load More");
        }
      } else {
        $button.hide();
        $productGrid.addClass("all-products-loaded");
      }

      $(".collection--empty").remove();
    },
    error: function () {
      $button.text("Error Loading Products");
    },
  });
}

// Helper Functions
function toggleButtonVisibility() {
  if (loadedProducts >= totalProducts) {
    $button.hide();
  } else {
    $button.show();
  }
}

function updateProductCounter() {
  $productCountText.text(`Showing (${loadedProducts} of ${totalProducts} products)`);
}

// COLLECTION PAGE LOAD MORE BUTTON CLICK DATA PAGINATION END JS

$(document).on("click", ".more__discount_text span", function (e) {
  $("body").addClass("coupon_cart_drawer_open");
  startCountdown();
});

function startCountdown() {
  $(".coupon_cart_drawer .timer").each(function () {
    console.log("Timer found");
    let $this = $(this);
    let hoursToEnd = parseInt($this.data("countdown"), 10); // Get hours from data attribute
    console.log("Countdown Hours:", hoursToEnd);

    if (isNaN(hoursToEnd)) return; // Skip if invalid

    let saleEndTime = new Date().getTime() + hoursToEnd * 60 * 60 * 1000;

    function updateTimer() {
      let now = new Date().getTime();
      let timeLeft = saleEndTime - now;

      if (timeLeft > 0) {
        let hours = Math.floor(timeLeft / (1000 * 60 * 60));
        let minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        $this.find(".hours").text(hours < 10 ? "0" + hours : hours);
        $this.find(".minutes").text(minutes < 10 ? "0" + minutes : minutes);
        $this.find(".seconds").text(seconds < 10 ? "0" + seconds : seconds);
      } else {
        $this.html("<span>Sale Ended</span>");
        clearInterval(timer);
      }
    }

    updateTimer();
    let timer = setInterval(updateTimer, 1000);
  });
}

// Close the cart drawer when clicking outside of it
$(document).on("click", function (e) {
  if (
    !$(e.target).closest(".coupon_cart_drawer, .more__discount_text").length
  ) {
    $("body").removeClass("coupon_cart_drawer_open");
  }
});
$(document).on("click", ".icon-close", function () {
  $("body").removeClass("coupon_cart_drawer_open");
});

$(".copy__button").click(function () {
  let couponText = $(this).attr("data-couponcode");
  let tempInput = $("<input>");
  $("body").append(tempInput);
  tempInput.val(couponText).select();
  document.execCommand("copy");
  tempInput.remove();
});

// NEW PRODUCT PAGE DESIGN OFFER BLOCK SLIDER STRAT
$(".offer-block-slider").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false,
  autoplaySpeed: 1000,
  draggable: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true,
      },
    },
  ],
});

// NEW PRODUCT PAGE DESIGN OFFER BLOCK SLIDER END

function initSlick() {
  if ($(window).width() < 801) {
    if (!$(".product-gallery-for").hasClass("slick-initialized")) {
      $(".product-gallery-for").slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // prevArrow:"<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>",
        // nextArrow:"<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>",
      });
    }
  } else {
    if ($(".product-gallery-for").hasClass("slick-initialized")) {
      $(".product-gallery-for").slick("unslick");
    }
  }
}

$(window).on("load resize", initSlick);

// function initSlick() {
//   if ($(window).width() < 768) {
//     if (!$('.image_and_text').hasClass('slick-initialized')) {
//       $('.image_and_text').slick({
//         dots: false,
//         infinite: true,
//         arrows: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//          autoplay: true,
//       });
//     }
//   } else {
//     if ($('.image_and_text').hasClass('slick-initialized')) {
//       $('.image_and_text').slick('unslick');
//     }
//   }
// }

// sections/featured-tabs-new.liquid
$(document).ready(function(){
	$('ul.ftabs .ftab-link').click(function(){
		var tab_id = $(this).attr('data-tab');
		$('ul.ftabs .ftab-link').removeClass('current');
		$('.ftab-content').removeClass('current');
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
});


// sections/bundle-block.liquid -- START
$(window).on('load', function () {
    $('.bundle_block_main').each(function () {
        var firstGridItem = $(this).find('.bundle_block_grid .bb_grid_item').first();
        var banner = $(this).find('.bundle_block_banner');

        if (firstGridItem.length && banner.length) {
            var height = firstGridItem.outerHeight();
            banner.css('height', height + 'px');
        }
    });
});

// sections/bundle-block.liquid -- END
$(document).on("click", ".variant_btn__addtocart", function (e) {
  var pid = $(this).attr("data-pid");
  let selectedVal = $(this).attr("data-vid");
  if(selectedVal){
    console.log("--->", "#" + pid + "-submit_pop_home");
    $('#home_p_hiden_id_'+pid).val(selectedVal);
    setTimeout(function () {
      $("#" + pid + "-submit_pop_home").trigger("click");
      $("body").removeClass("product_details_popup--active");
    }, 1000);
  }
});


$(document).on("change", ".variant_select__bundle", function (e) {
  var pid = $(this).attr("data-pid");
  let selectedVal = $(this).val(); 
  if(selectedVal){
    console.log("--->", "#" + pid + "-submit_pop_home");
    $('#home_p_hiden_id_'+pid).val(selectedVal);
    setTimeout(function () {
      $("#" + pid + "-submit_pop_home").trigger("click");
      $('.variant_select__bundle').prop('selectedIndex', 0); 

      $("body").removeClass("product_details_popup--active");
    }, 1000);
  }
});

// STORE BENEFITS -- START
$('.store_benefits_slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  infinite: true,
  dots: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 750,
      settings: [
        {
          slidesToShow: 1,
        }
      ]
    }
  ]
});
// STORE BENEFITS -- END